import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { pxToRem } from '../../../utils/pxToRem';
import { conventionContent } from '../content';
import { SectionInner } from '../components/SectionInner';
import { CornerFrame } from '../components/CornerFrame';

export function TheQuestion() {
  const { theQuestion } = conventionContent;
  return (
    <Box
      component="section"
      id={theQuestion.sectionId}
      aria-labelledby={theQuestion.headingId}
      sx={{
        backgroundColor: 'background.default',
        paddingBlock: { mobile: pxToRem(48), laptop: pxToRem(120) },
      }}
    >
      <SectionInner
        direction={{ mobile: 'column', laptop: 'row' }}
        gap={{ mobile: pxToRem(48), laptop: pxToRem(37) }}
        sx={{ alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            position: 'relative',
            width: { mobile: pxToRem(180.5), laptop: pxToRem(249) },
            height: { mobile: pxToRem(151.486), laptop: pxToRem(230) },
            flexShrink: 0,
          }}
        >
          <CornerFrame
            corner="bottom-right"
            inset={{
              mobile: { horizontal: 12.514, vertical: 13.173 },
              laptop: { horizontal: 19, vertical: 20 },
            }}
            radius={{ mobile: 17.783, laptop: 27 }}
          />
          <Typography
            component="h2"
            id={theQuestion.headingId}
            variant="h2"
            sx={{
              position: 'absolute',
              top: { mobile: 0, laptop: pxToRem(25) },
              left: { mobile: '50%', laptop: pxToRem(-1) },
              transform: { mobile: 'translateX(-50%)', laptop: 'none' },
              width: { mobile: pxToRem(165), laptop: pxToRem(226) },
              fontSize: { mobile: pxToRem(24), laptop: pxToRem(32) },
              lineHeight: { mobile: pxToRem(32), laptop: pxToRem(40) },
              textAlign: { mobile: 'center', laptop: 'left' },
              margin: 0,
            }}
          >
            {theQuestion.headingLines.map((line, i) => (
              <Box component="span" key={i} sx={{ display: 'block' }}>
                {line}
              </Box>
            ))}
          </Typography>
        </Box>
        <Stack
          gap={{ mobile: pxToRem(20), laptop: pxToRem(24) }}
          sx={{
            width: { mobile: '100%', laptop: pxToRem(447) },
            color: 'primary.main',
            textAlign: { mobile: 'center', laptop: 'left' },
          }}
        >
          {theQuestion.paragraphGroups.map((group, groupIndex) => (
            <Stack key={groupIndex} gap={{ mobile: pxToRem(20), laptop: 0 }}>
              {group.map((paragraph, index) => (
                <Typography
                  key={index}
                  variant="body1"
                  sx={{
                    fontSize: { mobile: pxToRem(16), laptop: pxToRem(22) },
                    lineHeight: { mobile: pxToRem(20), laptop: pxToRem(24) },
                    margin: 0,
                  }}
                >
                  {paragraph}
                </Typography>
              ))}
            </Stack>
          ))}
        </Stack>
      </SectionInner>
    </Box>
  );
}
